export default "__VITE_ASSET__CnO8mpr7__"